import { render, staticRenderFns } from "./PageFormSubmission.vue?vue&type=template&id=7c6a6479&scoped=true&"
import script from "./PageFormSubmission.vue?vue&type=script&lang=js&"
export * from "./PageFormSubmission.vue?vue&type=script&lang=js&"
import style0 from "./PageFormSubmission.vue?vue&type=style&index=0&id=7c6a6479&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a6479",
  null
  
)

export default component.exports